const Footer = () => (
  <footer className="bg-surface-inverse border-t border-surface-inverse-border px-6 lg:px-16 py-6">
    <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-5">
      <div className="flex items-center gap-4">
        <a
          href="https://www.linkedin.com/company/lumient-ai/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-surface-inverse-muted hover:text-surface-inverse-foreground transition-colors"
          aria-label="LinkedIn"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
        </a>
        <a
          href="https://x.com/lumientai"
          target="_blank"
          rel="noopener noreferrer"
          className="text-surface-inverse-muted hover:text-surface-inverse-foreground transition-colors"
          aria-label="X (Twitter)"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </a>
      </div>
      <div
        data-testid="footer-link-list"
        className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-xs text-surface-inverse-muted sm:justify-end"
      >
        <a href="/features" className="hover:text-surface-inverse-foreground transition-colors">Features</a>
        <a href="/pricing" className="hover:text-surface-inverse-foreground transition-colors">Pricing</a>
        <a href="/about" className="hover:text-surface-inverse-foreground transition-colors">About</a>
        <a href="/contact" className="hover:text-surface-inverse-foreground transition-colors">Contact</a>
        <a href="/privacy" className="hover:text-surface-inverse-foreground transition-colors">Privacy</a>
        <span>© 2026 Lumient AI</span>
      </div>
    </div>
  </footer>
);

export default Footer;
